import { render, staticRenderFns } from "./CarbonscoreDisplay.vue?vue&type=template&id=68b62b89&scoped=true"
import script from "./CarbonscoreDisplay.vue?vue&type=script&lang=ts"
export * from "./CarbonscoreDisplay.vue?vue&type=script&lang=ts"
import style0 from "./CarbonscoreDisplay.vue?vue&type=style&index=0&id=68b62b89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b62b89",
  null
  
)

export default component.exports